import { axios } from '~/clients';
import { HomeApiClientId } from '~/constants/common/ApiClientId';
import { getAnonymousRecentVehicles } from '~/constants/endpoints';
import {
  type RecentVehiclesRequest,
  type RecentVehiclesResponse
} from './fetchAuthenticatedRecentVehicles';

export default async function fetchAnonymousRecentVehicles(
  { browserCookieId, correlationId, count }: RecentVehiclesRequest,
  controller: AbortController
): Promise<RecentVehiclesResponse> {
  const url = getAnonymousRecentVehicles({
    currentPageUrl: window.location.href
  });
  const query = new URLSearchParams({
    browserCookieId,
    count: String(count)
  });

  const { data } = await axios.get<RecentVehiclesResponse>(
    `${url}?${query.toString()}`,
    {
      headers: {
        'x-client-id': HomeApiClientId,
        'x-correlation-id': correlationId
      },
      signal: controller.signal
    }
  );

  return data;
}
